import {
  protectedPost,
  protectedGet,
  protectedPatch,
  getServerBaseUrl,
  api,
} from "./restUtil";
export class UserStatus {
  static PENDING = "pending";
  static SUSPENDED = "suspended";
  static ACTIVE = "active";
  static DELETED = "deleted";

  static getAllUserStatuses() {
    return [
      UserStatus.PENDING,
      UserStatus.SUSPENDED,
      UserStatus.ACTIVE,
      UserStatus.DELETED,
    ];
  }
}

export function isPending(status) {
  return UserStatus.PENDING === status;
}

export function isSuspended(status) {
  return UserStatus.SUSPENDED === status;
}

export function isActive(status) {
  return UserStatus.ACTIVE === status;
}

export function isDeleted(status) {
  return UserStatus.DELETED === status;
}

export function logOut(args, onSuccess, onError) {
  return protectedPost(
    "/user/logout",
    args,
    resp => {
      return onSuccess && onSuccess(resp);
    },
    onError
  ); // TODO delete firebase token
}

export function getUserProfile() {
  return api.get("/user/profile", null, {
    onUnauthorized: () => {},
  });
}

//    possible fields
/*  {  first_name: "",
   last_name: "",
   nickname: "",
   gender: "male OR female",
   street_1:"",
   street_2:"",
   city:"",
   state:"",
   zip:"",
   country:"",
   native_language: "en_US",
   bio:"",
   hobbies:"",
   utc_offset: "+00:00",}*/

export function patchUserProfile(args, onSuccess, onError) {
  return protectedPatch(
    "/user/profile",
    {
      first_name: args.first_name,
      last_name: args.last_name,
      native_language: args.native_language ? args.native_language.code : undefined,
      // utc_offset: args.utc_offset ? args.utc_offset.split(" ")[0] : null,
      timezone: args.timezone ? args.timezone.id : undefined,
      title: args.title,
      industry: args.industry,
      city: args.address ? args.address.city : undefined,
      country: args.address ? args.address.country : undefined,
      state: args.address ? args.address.state : undefined,
      localization_lang: args.localization_lang ? args.localization_lang : undefined,
    },
    function () {
      return onSuccess && onSuccess(args);
    },
    onError
  );
}

export function updateUserLocation(args) {
  return api.patch("/user/profile", {
    timezone: args.timezone.id,
    city: args.address.city,
    country: args.address.country,
    state: args.address.state,
  });
}

export function getUserProfileById(args, onSuccess, onError) {
  return protectedGet("/user/" + args.id + "/profile", undefined, onSuccess, onError);
}

export function patchTeachingProfile(args, onSuccess, onError) {
  return protectedPatch(
    "/user/profile",
    {
      bio: args.bio,
    },
    function () {
      return onSuccess && onSuccess(args);
    },
    onError
  );
}

export function getUserAvatarUrl(userId) {
  return getServerBaseUrl() + "/user/" + userId + "/profile/avatar";
}

export function getOTPQRCodeUrl() {
  return `${getServerBaseUrl()}/user/totp`;
}

export function patchMFAState(args, onSuccess, onError) {
  return protectedPatch("/user/mfa", args, onSuccess, onError);
}

export function commonUploadUserAvatar(args, onSuccess, onError) {
  protectedPost(args.url, args.file, onSuccess, onError, {
    contentType: args.contentType,
  });
}

export function uploadUserAvatar(args, onSuccess, onError) {
  args.url = "/user/profile/avatar";
  commonUploadUserAvatar(args, onSuccess, onError);
}

export function fetchOwnStudentData(args, onSuccess, onError) {
  return protectedGet("/student", args, onSuccess, onError);
}

export function fetchOwnInstructorData(args, onSuccess, onError) {
  return protectedGet("/instructor", args, onSuccess, onError);
}

export function getUserLastSeen(args, onSuccess, onError) {
  return protectedGet(
    "/user/" + args.id + "/profile/lastseen",
    undefined,
    onSuccess,
    onError
  );
}

export function saveLikeOnFB(args, onSuccess, onError) {
  return protectedPatch(
    "/user/profile",
    {
      liked_on_facebook: true,
    },
    onSuccess,
    onError
  );
}

export function updateUserTitle(args, onSuccess, onError) {
  return protectedPatch(
    "/user/profile",
    {
      title: args.title,
    },
    function () {
      return onSuccess && onSuccess(args);
    },
    onError
  );
}

export function getStudentTest(onSuccess, onError) {
  return protectedGet("/adaptive/test", undefined, onSuccess, onError);
}

export function startNewStudentTest(args, onSuccess, onError) {
  return protectedPost("/adaptive/tests", { level_id: args.levelId }, onSuccess, onError);
}

export function submitStudentTestAnswer(args, onSuccess, onError) {
  return protectedPost(
    "/adaptive/test/submission",
    { answer_option_id: args.optionId },
    onSuccess,
    onError
  );
}
